/**
 * Shared asset-related types used across multiple services
 */

export enum AssetSetType {
  DroneImages = 'drone_images',
  OdmOutputs = 'odm_outputs',
  Lidar = 'lidar',
  MapLayers = 'map_layers',
  GCPOutputs = 'gcp_outputs',
  Other = 'other',
}

export enum AssetContentType {
  Model3D = '3d_model',
  PointCloud = 'point_cloud',
  Orthomosaic = 'orthomosaic',
  Dsm = 'dsm',
  Dtm = 'dtm',
}

/**
 * How the UI groups an asset set's contents (droidmap#2887).
 *
 * A *presentation* grouping, distinct from the content facets in
 * `ASSET_TYPE_FACETS`: `data` deliberately spans three facets, and `imagery`
 * and `model` overlap depending on the parent set. Named here, beside
 * {@link AssetType} and {@link AssetSetType}, so the contract can carry
 * per-category counts without depending on the package that computes them.
 */
export const ASSET_CATEGORY_KEYS = [
  'map',
  'model',
  'imagery',
  'data',
  'documents',
  'other',
] as const

export type AssetCategoryKey = (typeof ASSET_CATEGORY_KEYS)[number]

export enum AssetType {
  Bin = 'bin',
  Cog = 'cog',
  Csv = 'csv',
  Dsm = 'dsm',
  Dtm = 'dtm',
  GeoTiff = 'geotiff',
  Geojson = 'geojson',
  Glb = 'glb',
  Gltf = 'gltf',
  Gpkg = 'gpkg',
  Jpeg = 'jpeg',
  Json = 'json',
  Las = 'las',
  Laz = 'laz',
  Mrk = 'mrk',
  Mtl = 'mtl',
  Nav = 'nav',
  Obj = 'obj',
  Obs = 'obs',
  Other = 'other',
  Pdf = 'pdf',
  Ply = 'ply',
  Png = 'png',
  Raw = 'raw',
  Tiff = 'tiff',
  Txt = 'txt',
}
